<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="con" title="Contents">
<p class="fmh"><span class="right_1" epub:type="pagebreak" id="page_v" title="v"><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi">CONTENTS</span></span></p>
<p class="toc_1" id="rtit"><span href="#/text/Title" title="Link target outside of Sample">TITLE PAGE</span></p>
<p class="toc_1" id="rcop"><span href="#/text/Copyright" title="Link target outside of Sample">COPYRIGHT</span></p>
<p class="toc_1" id="rded"><span href="#/text/Dedication" title="Link target outside of Sample">DEDICATION</span></p>
<p class="toc_2" id="rint"><a href="#/text/Introduction">Introduction by <i>Renée Watson</i></a></p>
<p class="toc_1" id="rpre"><a href="#/text/Preface">Preface by <i>Ethel Johnston Phelps</i></a></p>
<p class="toc_2" id="rch1"><span href="#/text/Chapter01" title="Link target outside of Sample">Mulha</span></p>
<p class="toc_1" id="rch2"><span href="#/text/Chapter02" title="Link target outside of Sample">The Hunter Maiden</span></p>
<p class="toc_1" id="rch3"><span href="#/text/Chapter03" title="Link target outside of Sample">Elsa and the Evil Wizard</span></p>
<p class="toc_1" id="rch4"><span href="#/text/Chapter04" title="Link target outside of Sample">Maria Morevna</span></p>
<p class="toc_1" id="rch5"><span href="#/text/Chapter05" title="Link target outside of Sample">Duffy and the Devil</span></p>
<p class="toc_1" id="rch6"><span href="#/text/Chapter06" title="Link target outside of Sample">Lanval and the Lady Triamor</span></p>
<p class="toc_1" id="rch7"><span href="#/text/Chapter07" title="Link target outside of Sample">Bending Willow</span></p>
<p class="toc_1" id="rch8"><span href="#/text/Chapter08" title="Link target outside of Sample">Finn Magic</span></p>
<p class="toc_1" id="rch9"><span href="#/text/Chapter09" title="Link target outside of Sample">The Old Woman and the Rice Cakes</span></p>
<p class="toc_1" id="rch10"><span href="#/text/Chapter10" title="Link target outside of Sample">The Husband Who Stayed at Home</span></p>
<p class="toc_1" id="rch11"><span href="#/text/Chapter11" title="Link target outside of Sample">Scheherazade Retold</span></p>
<p class="toc_2" id="rbib"><span href="#/text/Bibliography" title="Link target outside of Sample">Suggested Reading</span></p>
<p class="toc_1" id="rack"><span href="#/text/Acknowledgments" title="Link target outside of Sample"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">Acknowledgments</span></span></p>
<p class="toc_1" id="rtea"><span href="#/text/Teaser" title="Link target outside of Sample">Series Teaser</span></p>
<p class="toc_2" id="raut"><span href="#/text/Author" title="Link target outside of Sample">ABOUT THE EDITOR and ILLUSTRATOR</span></p>
<p class="toc_1" id="rals"><span href="#/text/Also_by" title="Link target outside of Sample">ALSO BY FEMINIST PRESS</span></p>
<p class="toc_1" id="ratp"><span href="#/text/Publisher" title="Link target outside of Sample">ABOUT FEMINIST PRESS</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?0ce23459